import { scrollToElementId } from 'src/common/helpers/functions/scrollToElementId'

/**
 * @param {string[] | Record<PropertyKey, any>} error
 * @returns {string[]}
 */
export const errorArrayGenerator = (error) => {
  // Server error
  if (error?.response?.data && 'success' in error?.response?.data && !error?.response?.data.success) {
    const errorObj = error?.response?.data?.error ?? {}
    return 'batch_messages' in errorObj
      ? errorObj.batch_messages
      : 'message' in errorObj
        ? [errorObj.message]
        : ['Error communicating with the server.']
  }
  // AJV error
  else if (typeof error === 'object' && Array.isArray(error)) {
    return error
  }
  // Other Types of error
  else return ['Something went wrong']
}

export const raiseError = (errorText) => {
  const error = {
    response: {
      data: {
        success: false,
        error: {
          message: errorText,
        },
      },
    },
  }
  throw error
}

export const imageErrorFiller = (errors, image_type, image) => {
  // @Reza
  const imageErrorMessage = 'Image is not available.'
  const errorIndex = errors.indexOf(imageErrorMessage)
  const hasError = errorIndex !== -1
  const shouldAddError = image_type === 0 && !image.length

  if (!hasError && shouldAddError) errors.push(imageErrorMessage)
  else if (hasError && !shouldAddError) errors.splice(errorIndex, 1)
}

/**
 * @param {Record<PropertyKey, any>} fillableState
 * @param {{id: string; objectKey: string}} opt
 * @returns {string[]}
 */
export const catchError = (error, fillableState = { errors: [] }, opt = { id: 'error-box', objectKey: 'errors' }) => {
  const errors = errorArrayGenerator(error)
  fillableState[opt.objectKey] = errors
  if (errors?.length) scrollToElementId(opt.id, { behavior: 'smooth', block: 'end' })

  return errors
}
